if (typeof ScrollingText !== 'function') {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			const ScrollingTextEngine = (function () {
				function getWidth(element) {
					const rect = element.getBoundingClientRect();

					return rect.right - rect.left;
				}

				function ScrollingTextEngine(box, speed) {
					const innerElement = (box.children && box.children[0]) || null;

					if (!innerElement) {
						throw 'No child node found';
					}

					innerElement.style.position = 'relative';

					this.position = 0;
					this.speed = speed;
					this.box_width = getWidth(box);
					this.inner_element_width = getWidth(innerElement);
					this.box = box;
					this.inner_element = innerElement.cloneNode(true);
					setUpChildrens.call(this);
				}

				function refreshWidths() {
					this.box_width = getWidth(this.box);
					this.inner_element_width = getWidth(this.box.children[0]);
				}

				function calculateNumElements() {
					return Math.ceil(this.box_width / this.inner_element_width) + 1;
				}

				function setUpChildrens() {
					const qty = calculateNumElements.call(this);

					if (qty > this.box.children.length) {
						for (let i = this.box.children.length; i < qty; i++) {
							this.box.appendChild(this.inner_element.cloneNode(true));
						}
					} else if (qty < this.box.children.length) {
						for (let i = qty; i < this.box.children.length; i++) {
							this.box.removeChild(this.box.lastChild);
						}
					}
				}

				function nextFrame(delta, direction) {
					const self = this;

					refreshWidths.call(this);
					setUpChildrens.call(this);
					Array.prototype.forEach.call(this.box.children, (el) => {
						if (direction == 'rtl') {
							el.style.transform = `translateX(${self.position}px)`;
						} else {
							el.style.transform = `translateX(${-self.position}px)`;
						}
					});
					this.position += (this.speed * delta) / 1000;
					if (this.position >= this.inner_element_width) {
						this.position = this.position % this.inner_element_width;
					}
				}

				ScrollingTextEngine.prototype = {
					start: function (direction) {
						this._running = true;
						const self = this;
						let lastTime = null;
						const loopFunc = function () {
							if (!self._running) {
								return;
							}

							const now = Date.now();
							const delta = lastTime === null ? 0 : now - lastTime;

							nextFrame.call(self, delta, direction);
							lastTime = now;
							window.requestAnimationFrame(loopFunc);
						};

						window.requestAnimationFrame(loopFunc);
					},

					stop: function () {
						this._running = false;
					},
				};

				return ScrollingTextEngine;
			})();

			const speed =
				window.innerWidth > 768 ? parseInt(this.dataset.scrollingSpeed) : parseInt(this.dataset.scrollingSpeed) / 1.5;
			const direction = this.dataset.scrollingDirection;
			const scrollingText = new ScrollingTextEngine(this, speed, direction);

			this.__scrollEngine = scrollingText;
			this.__scrollDirection = direction;
			this.__inView = false;
			this.__pausedByHover = false;
			this.__pausedByVideo = false;
			this.__suppressHoverPauseUntil = 0;

			this.shouldIgnoreHoverPause = () => {
				if (Date.now() < this.__suppressHoverPauseUntil) {
					return true;
				}

				const row = this.closest('video-carousel-row');

				if (!row) {
					return false;
				}

				return Boolean(
					row.querySelector('.video-carousel-card--playing, .video-carousel-card--loading'),
				);
			};

			this.suppressHoverPause = (durationMs = 500) => {
				this.__suppressHoverPauseUntil = Date.now() + durationMs;
			};

			this.syncScrollState = () => {
				if (this.__inView && !this.__pausedByHover && !this.__pausedByVideo) {
					scrollingText.start(direction);
				} else {
					scrollingText.stop();
				}
			};

			if (this.dataset.pauseOnHover == 'true') {
				const carousel = this;
				let windowInFocus = true;

				window.addEventListener('blur', () => {
					windowInFocus = false;
				});

				window.addEventListener('focus', () => {
					windowInFocus = true;
				});

				carousel.addEventListener('mouseover', () => {
					if (windowInFocus && !carousel.shouldIgnoreHoverPause()) {
						carousel.__pausedByHover = true;
						carousel.syncScrollState();
					}
				});

				carousel.addEventListener('mouseout', () => {
					if (windowInFocus) {
						carousel.__pausedByHover = false;
						carousel.syncScrollState();
					}
				});
			}

			this.addEventListener('on:scrolling-text:pause', (event) => {
				if (event.detail?.reason === 'video') {
					this.__pausedByVideo = true;
					this.suppressHoverPause();
					this.syncScrollState();
				}
			});

			this.addEventListener('on:scrolling-text:resume', (event) => {
				if (event.detail?.reason === 'video') {
					this.__pausedByVideo = false;

					if (event.detail?.force) {
						this.__pausedByHover = false;
					}

					this.suppressHoverPause();
					this.syncScrollState();
				}
			});

			const intersectionObserver = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					this.__inView = true;
					this.syncScrollState();
				} else {
					this.__inView = false;
					scrollingText.stop();
				}
			});

			intersectionObserver.observe(this);
		}
	}

	if (typeof customElements.get('scrolling-text') == 'undefined') {
		customElements.define('scrolling-text', ScrollingText);
	}
}
